import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ReceptionDetail } from "../reception-detail";
import { SupplierReference } from "../../reference/supplier-reference";
import { Reception } from "../reception";
import { ReceptionService } from "../reception-service";
import { Invoice } from "src/app/purchase/invoice/invoice";

@Component({
  selector: "tr[reception-detail]",
  templateUrl: "./reception-detail.component.html"
})
export class ReceptionDetailComponent implements OnChanges, OnInit {
  @Input()
  detail!: ReceptionDetail;

  @Input()
  detailsReceived!: ReceptionDetail[];

  @Input()
  detailsToReceive!: ReceptionDetail[];

  @Input()
  invoice!: Invoice;

  @Input()
  reception!: Reception;

  @Input()
  showReceived!: boolean;

  @Input()
  readOnly!: boolean;

  @Input()
  referencesPrintToggle!: Set<string>;

  priceChange!: number;
  priceOverride!: number;
  price!: number;
  supplierReference!: SupplierReference;

  constructor(private receptionService: ReceptionService) {

  }

  public getPrice(): number {
    return this.supplierReference != null && this.supplierReference.retailPrice != 0 ? this.supplierReference.retailPrice / 100 : 0;
  }

  public isPrintLabelEnabled(detail: ReceptionDetail): boolean {
    return this.referencesPrintToggle.has(detail.reference.isbn);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.price == undefined) {
      this.computePrices();
    }

    if(changes.invoice != null && changes.invoice.currentValue != null) {
      for(const invoiceDetail of this.invoice.details) {
        if(invoiceDetail.reference.isbn == this.detail.reference.isbn && this.price != invoiceDetail.costPrice) {
          this.priceChange = invoiceDetail.costPrice;
        }
      }
    }
  }

  ngOnInit(): void {
    if(this.price == undefined) {
      this.computePrices();
    }
  }

  computePrices() {
    for (const supplierReference of this.detail.reference.supplierReferences) {
      if (supplierReference.supplier.id == this.reception.supplier.id) {
        this.supplierReference = supplierReference;
        this.price = this.supplierReference.retailPrice;
        this.priceOverride = this.supplierReference.retailPriceOverride;
      }
    }
  }

  public removeDetails(detail: ReceptionDetail) {
    this.readOnly = true;
    detail.updating = true;

    this.receptionService.removeDetail(this.reception.id, detail.reference.isbn)

      .subscribe({
        next: _ => this.removeDetailsSuccess(detail),
        complete: () => this.readOnly = false
      });
  }

  private removeDetailsSuccess(detail: ReceptionDetail) {
    const index = this.detailsReceived.indexOf(detail, 0);
    if (index > -1) {
      this.detailsReceived.splice(index, 1);
    }

    if (detail.orderedQuantity != 0 || detail.shippedQuantity != 0) {
      detail.receivedQuantity = 0;

      this.detailsToReceive.push(detail);
    }
  }

  public togglePrintLabel(detail: ReceptionDetail) {
    if (this.isPrintLabelEnabled(detail)) {
      this.referencesPrintToggle.delete(detail.reference.isbn);
    } else {
      this.referencesPrintToggle.add(detail.reference.isbn);
    }
  }
}